import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { ByaHttp } from 'app/services/bya-http';
import { Observable } from 'rxjs';
import { VigenciaFiscal } from '../models/vigencia-fiscal';
import { tap, catchError } from 'rxjs/operators';
import { AuthService } from '../../../../@bya/auth/services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class VigenciaFiscalService  extends ByaHttp {

  constructor(
    private http: HttpClient,
	  protected dialog: MatDialog, private _authService: AuthService
  ) { 
	  super(dialog, _authService);
  }

  getAll(): Observable<VigenciaFiscal[]> {
    return this.http.get<VigenciaFiscal[]>(this.baseUrl + 'api/Vigencia')
      .pipe(
        tap(_ => this.log('fetched task')),
        catchError(this.handleError<VigenciaFiscal[]>('OBTENER VIGENCIAS FISCALES', []))
      );
  }

  post(vigencia: VigenciaFiscal): Observable<any> {
    return this.http.post<VigenciaFiscal>(this.baseUrl + 'api/Vigencia', vigencia)
      .pipe(
        tap(_ => this.log('fetched task')),
        catchError(this.handleError<VigenciaFiscal>('GUARDAR VIGENCIA FISCAL', null))
      );
  }

  activarVigencia(vigencia: VigenciaFiscal): Observable<any> {
    return this.http.put<VigenciaFiscal>(this.baseUrl + 'api/Vigencia/Activar', vigencia)
      .pipe(
        tap(_ => this.log('fetched task')),
        catchError(this.handleError<VigenciaFiscal>('CERRAR VIGENCIA FISCAL', null))
      );
  }

  cerrarVigencia(vigencia: VigenciaFiscal): Observable<any> {
    return this.http.put<VigenciaFiscal>(this.baseUrl + 'api/Vigencia/Cerrar', vigencia)
      .pipe(
        tap(_ => this.log('fetched task')),
        catchError(this.handleError<VigenciaFiscal>('CERRAR VIGENCIA FISCAL', null))
      );
  }
}
